module.exports = __webpack_public_path__ + "img/ice_troll_voodoo_hut_small.ff37687a.png";